<template>
  <div :class="[imageClass, imageState]" :style="computedStyle" :data-width="imageWidth" :data-height="imageHeight" :data-state="imageState">
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  props: {
    imageSource: {
      type: String,
      required: true
    },
    imageClass: {
      type: String,
      required: false,
      default: ''
    },
    loadingImage: {
      type: String,
      required: false
    },
    errorImage: {
      type: String,
      required: false
    },
    imageErrorCallback: {
      type: Function,
      required: false,
      default: function() {}
    },
    imageSuccessCallback: {
      type: Function,
      required: false,
      default: function() {}
    },
    backgroundSize: {
      type: String,
      required: false,
      default: 'cover'
    }
  },
  data() {
    return {
      imageWidth: 0,
      imageHeight: 0,
      imageState: 'loading',
      asyncImage: new Image()
    }
  },
  computed: {
    computedStyle() {
      if (this.imageState === 'loading' && this.loadingImage) {
        return { 
          // 'background-repeat': 'no-repeat',
          'background-image': 'url(' + this.loadingImage + ')',
          '-webkit-filter': 'blur(25px)',
          '-moz-filter': 'blur(25px)',
          '-o-filter': 'blur(25px)',
          '-ms-filter': 'blur(25px)',
          'filter': 'blur(25px)'
        }
      }
      if (this.imageState === 'error' && this.errorImage) {
        return { 
          // 'background-repeat': 'no-repeat',
          'background-image': 'url(' + this.errorImage + ')',
          '-webkit-filter': 'blur(25px)',
          '-moz-filter': 'blur(25px)',
          '-o-filter': 'blur(25px)',
          '-ms-filter': 'blur(25px)',
          'filter': 'blur(25px)'
        }
      }
      if (this.imageState === 'loaded') {
        return 'background-image: url(' + this.asyncImage.src + '); background-size: ' + this.backgroundSize
      }
      return '';
    }
  },
  methods: {
    fetchImage(url) {
      this.asyncImage.onload = this.imageOnLoad
      this.asyncImage.onerror = this.imageOnError
      this.imageState = 'loading'
      this.asyncImage.src = this.imageSource
    },
    imageOnLoad(success) {
      this.imageState = 'loaded'
      this.imageWidth =  this.asyncImage.naturalWidth
      this.imageHeight = this.asyncImage.naturalHeight
      this.imageSuccessCallback()
    },
    imageOnError(error) {
      this.imageState = 'error'
      this.imageErrorCallback()
    }
  },
  created() {
    console.log(this.imageSource)
  },
  mounted() {
    this.$nextTick(() => {
      console.log('in next tick')
      this.fetchImage()
    })
  }
}
</script>


// WEBPACK FOOTER //
// core/vue/components/LazyBackground.vue